import React, { useState, useEffect, useRef, useMemo, useCallback} from 'react';
import { AgGridReact } from "ag-grid-react";
import { AllEnterpriseModule } from 'ag-grid-enterprise';
import { ModuleRegistry, AllCommunityModule, themeBalham } from 'ag-grid-community';
import { useDispatch, useSelector } from "react-redux";
import { Drawer } from '@material-ui/core';
import { Snackbar } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { isEmpty, CellType, setglobaldata, arrayDiff, getglobaldata, DeepCopy } from '../modules/appLibrary';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import CustomToolPanel from "../components/CustomToolPanel";
import CustomToolorgPanel from "../components/CustomToolorgPanel";
import { makeStyles } from '@material-ui/core/styles';
import TagRenderer from "./RenderTag.js";
import {  setsearchtoolpanel, searchaddlayout } from '../modules/searchliststore';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

// 必要なモジュールを登録
ModuleRegistry.registerModules([
    AllEnterpriseModule,
    AllCommunityModule
]);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        padding: '0 10px',
        height: 30,
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    divider: {
        height: 28,
        margin: 4,
    },
   chip: {
        margin: theme.spacing(0.2),
    },
    snackbar: {
        maxWidth:250,
        backgroundColor: '#F7F8F9',
        color: '#000',
    }
}));


//---------------------------------------------------------------------
//  SKU検索リスト 製品/附属
//
//---------------------------------------------------------------------
export default function SearchList(props) {
    const AGRef = useRef();
    const fnc = useRef();
    const dispatch = useDispatch();
    const ComFunc = React.forwardRef(ComFunction);
    const AGFunc = React.forwardRef(AGFunction);

    const open = useSelector(state => state.search.skuopen);
    const datainfo = useSelector(state => state.search.data);
    const rowid = useSelector(state => state.search.rowid);
    const currowid = useSelector(state => state.search.currowid);
    const doApply = useSelector(state => state.search.doApply);
    const rowdata = useSelector(state => state.search.rowdata);
    const columninfo = useSelector(state => state.search.columninfo);

    const apiRefcolor = useRef({ grid: undefined, column: undefined });
    const apiRefsize = useRef({ grid: undefined, column: undefined });

    const [show, setshow] = useState(false);
    const [colorrowData, setcolorRowData] = useState([]);
    const [colorcolumns, setcolorColumns] = useState([]);
    const [sizerowData, setsizeRowData] = useState([]);
    const [sizecolumns, setsizeColumns] = useState([]);
    const [showselect, setshowselect] = useState(false);  //snackbar
    const [colorlists, setcolorlists ] = useState([]);
    const [sizelists, setsizelists] = useState([]);
    const [value, setValue] = React.useState(0);    //0:color 1:size
    const [key, setkey] = React.useState('');    //main code
    const [sku, setsku] = React.useState(true);    //原材料=false

    const CELLTYPE = CellType();
    const classes = useStyles();
    const [toolpanels, settoolpanels] = useState([]);
    const colfixkey = "search_colfix"; //列幅最適化
    const vertical = "bottom";
    const horizontal = "right";
    const rowSelection = 'multiple';
    const useSearchPanel = false;

    const icons = useMemo(() => {
        return {
            'custom-tools': '<i class="material-icons min">star</i>',
            'custom-tools2': '<i class="material-icons min">table_chart</i>',
        };
    }, []);
   const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: true,
        wrapText: true,
        menuTabs: ['filterMenuTab', 'generalMenuTab'],
        tooltipValueGetter: (params) => { return params.column.colId.indexOf( 'name') !== -1 || params.column.colId === 'tag' ? params.value : null; }
    };

    useEffect(() => {
        //通常
        setshow(open);
        if (open) {
            setsku(dataid().indexOf("m_matl") === -1);
            setshowselect(false);
            setcolorlists([]);
            setsizelists([]);
            GetMasterList();
            toolpanel();
            if (dataid().indexOf("color") !== -1) setValue("0");
            else setValue("1");
        } else {
            setcolorColumns([]);
            setcolorRowData([]);
            setsizeColumns([]);
            setsizeRowData([]);
        }
    }, [open])

    const count = useRef(0);
    useEffect(() => {
        if (!open) return;
        if (value === "0" && isEmpty(apiRefcolor.current.grid)) return;
        if (value === "1" && isEmpty(apiRefsize.current.grid)) return;
        if (value === "0" && colorlists.length === 0) return;
        if (value === "1" && sizelists.length === 0) return;
        //切り替えを待って選択状態をセット
        const intervalId = setInterval(() => {
            count.current++;
            let setting = false;
            if (value === "0") {
                if (apiRefcolor.current.grid.getDisplayedRowCount() !== 0) {
                    for (let i = 0; i < colorlists.length; i++) {
                        let node = apiRefcolor.current.grid.getRowNode(colorlists[i].rowid);
                        if (!isEmpty(node)) {
                            node.setSelected(true);
                        }
                    }
                    setting = true;
                }
            }
            if (value === "1") {
                if (apiRefsize.current.grid.getDisplayedRowCount() !== 0) {
                    for (let i = 0; i < sizelists.length; i++) {
                        let node = apiRefsize.current.grid.getRowNode(sizelists[i].rowid);
                        if (!isEmpty(node)) {
                            node.setSelected(true);
                        }
                    }
                    setting = true;
                }
            }
            if (count.current > 5 || setting) {
                clearInterval(intervalId);
            }
        }, 100);
    }, [value])

    function dataid(type) {
        const baseId = datainfo?.dataid;
        if (!baseId) return "";
        if (isEmpty(type)) {
            return datainfo.dataid;
        } else {
            let id = datainfo.dataid;
            if (type === "0") {
                if (id.indexOf("color") === -1) id = id.replace( "size", "color");
            } else {
                if (id.indexOf("size") === -1) id = id.replace("color", "size");
            }
            return id;
        }
    }
 
    //マスタリスト取得
    async function GetMasterList() {
        setkey(rowdata[datainfo.keyinfo.split("=")[1]]);
        try {
            fnc.current.postaxios('common/GetSearchSKUList',
                {
                    "dataid": dataid(),
                    "rowdata": rowdata,
                    "keyinfo": datainfo.keyinfo,
                    "colinfo": columninfo
                },
                {
                    onSuccess: function (data) {
                        setglobaldata(colfixkey, false);
                        //color
                        let coldef = data.color.coldef;
                        if (coldef.length===0) {
                            coldef = createColDef(data.color.colinfo, data.color.columns, data.color.prelayout, "0");
                            setglobaldata(colfixkey, data.color.fitColumn);    //リアルタイム反映
                            dispatch(setsearchtoolpanel({
                                layouts: data.color.layouts, prelayout: data.color.prelayout,
                                initlayout: data.color.initlayout.length === 0 ? " " : data.color.initlayout,
                                fitColumn: data.color.fitColumn
                            }));
                        }
                        setcolorColumns(coldef);
                        setcolorRowData(data.color.rowdata);
                        if (data.color.rowdata.length !== 0)
                            fnc.current.asignMaster(dataid("0"), data.color.rowdata);
                        //size
                        coldef = data.size.coldef;
                        if (coldef.length === 0) {
                            coldef = createColDef(data.size.colinfo, data.size.columns, data.size.prelayout, "1");
                            setglobaldata(colfixkey, data.size.fitColumn);    //リアルタイム反映
                            dispatch(setsearchtoolpanel({
                                layouts: data.size.layouts, prelayout: data.size.prelayout,
                                initlayout: data.size.initlayout.length === 0 ? " " : data.size.initlayout,
                                fitColumn: data.size.fitColumn
                            }));
                        }
                        setsizeColumns(coldef);
                        setsizeRowData(data.size.rowdata);
                        if (data.size.rowdata.length !== 0)
                            fnc.current.asignMaster(dataid("1"), data.size.rowdata);
                        fnc.current.wait(false);
                }
            })
        } catch (error) {
            console.log(error);
        }
    }
    const RowNodeId = (data) => {
        return data.rowid;
    };
    function createColDef(all, columns, prelayout, type) {
        var colDef = [];
        try {
            for (let i = 0; i < all.length; i++) {
                let hide = false;
                let result = columns.filter(e => e.columnid === all[i].columnid);
                hide = result.length === 0;
                let column = {
                    headerName: all[i].columnnm,
                    field: all[i].columnid,
                    colId: all[i].columnid,
                    hide: hide,
                    editable: false,
                    datatype: all[i].datatype,
                    colinfo: all[i]
                }
                if (!hide) {
                    column['width'] = result.width;
                //    column['pinned'] = result.pin;
                }

                AGRef.current.SetColDefTypeInfo(all[i].datatype, column);

                colDef.push(column);
            }
        } catch (error) {
            console.log(error);
        }
        //前回レイアウト適用
        if (prelayout) {
            colDef = AGRef.current.GetColState(storagekey(type), colDef);
        }
        return colDef;
    }
    //レイアウト呼び出し
    function calllayout(layoutid) {
        fnc.current.postaxios('common/GetListColumns',
            { "controller": dataid(value), "subkey": props.subkey, "type": "1000", "code": layoutid },
            {
                onSuccess: function (data) {
                    createColDef(data.colinfo, data.columns, false,value);
                    AGRef.current.SaveColState(storagekey(value));
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト登録
    function savelayout(layoutid) {
        fnc.current.postaxios('common/SaveLayout',
            {
                "controller": dataid(value), "subkey": props.subkey, "type": "1000",
                "code": layoutid,
                "coldef": AGRef.current.GetshownColDef(value === "0" ? apiRefcolor.current.column : apiRefsize.current.column)
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(searchaddlayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }

    //mode:0=適用 2:DoubleClick
    function Execute(mode, selectnode) {
        if (mode !== 2) {
            if (colorlists.length === 0 && sizelists.length === 0) {
                fnc.current.warnmsg("データを選択してください");
                return;
            }
        }

        let colorid = "";
        let sizeid = "";
        let colorinfo = datainfo;
        let sizeinfo = datainfo;
        if (dataid().indexOf("color") !== -1) {
            colorid = datainfo.columnid;
            if (dataid().indexOf("m_matl") === -1) {  //原材料以外
                let col = columninfo.find(e => e.dataid === dataid("1"));
                sizeid = col.columnid;
                sizeinfo = col;
            }
        } else {
            sizeid = datainfo.columnid;
            let col = columninfo.find(e=>e.dataid===dataid("0"));
            colorid = col.columnid;
            colorinfo = col;
        }
        if (mode === 2) {
            let items = [{ color: value === "0" ? selectnode.data : null, size: value === "1" ? selectnode.data : null }];
            let data = {
                colorkey: colorid,
                sizekey: sizeid,
                items: items,
                colorinfo: colorinfo,
                sizeinfo:sizeinfo,
                rowid: rowid,
                currowid: currowid,
                datainfo: datainfo,
                rowmode: true
            };
            doApply(data, mode)
        } else {
            let useCheck = false;
            let items = [];
            if (colorlists.length !== 0 && sizelists.length !== 0) {
                for (let i = 0; i < colorlists.length; i++) {
                    for (let j = 0; j < sizelists.length; j++) {
                        let row = { color: colorlists[i], size: sizelists[j] };
                        items.push(row);
                    }
                }
                if (dataid().indexOf("smatl") !== -1) useCheck = true;
            } else {
                if (colorlists.length !== 0) {
                    for (let i = 0; i < colorlists.length; i++) {
                        let row = { color: colorlists[i], size: null };
                        items.push(row);
                    }
                }
                if (sizelists.length !== 0) {
                    for (let i = 0; i < sizelists.length; i++) {
                        let row = { color: null, size: sizelists[i] };
                        items.push(row);
                    }
                }
            }
            let data = {
                colorkey: colorid,
                sizekey:sizeid,
                items: items,
                colorinfo: colorinfo,
                sizeinfo: sizeinfo,
                rowid: rowid,
                currowid: currowid,
                datainfo: datainfo,
                rowmode:true
            };
            if (!useCheck) {
                doApply(data, mode)
            } else {
                //副資材の場合使用不可SKUチェック
                SMaterialTargetSKU(data, mode)
            }
        }
    }
    function AllExecute() {
        let colorid = "";
        let sizeid = "";
        let colorinfo = datainfo;
        let sizeinfo = datainfo;
        if (dataid().indexOf("color") !== -1) {
            colorid = datainfo.columnid;
            if (dataid().indexOf("m_matl") === -1) {  //原材料以外
                let col = columninfo.find(e => e.dataid === dataid("1"));
                sizeid = col.columnid;
                sizeinfo = col;
            }
        } else {
            sizeid = datainfo.columnid;
            let col = columninfo.find(e => e.dataid === dataid("0"));
            colorid = col.columnid;
            colorinfo = col;
        }
        let useCheck = false;
        let items = [];
        if (colorrowData.length !== 0 && sizerowData.length !== 0) {
            for (let i = 0; i < colorrowData.length; i++) {
                for (let j = 0; j < sizerowData.length; j++) {
                    let row = { color: colorrowData[i], size: sizerowData[j] };
                    items.push(row);
                }
            }
            if (dataid().indexOf("smatl") !== -1) useCheck = true;
        } else {
            if (colorrowData.length !== 0) {
                for (let i = 0; i < colorrowData.length; i++) {
                    let row = { color: colorrowData[i], size: null };
                    items.push(row);
                }
            }
            if (sizerowData.length !== 0) {
                for (let i = 0; i < sizerowData.length; i++) {
                    let row = { color: null, size: sizerowData[i] };
                    items.push(row);
                }
            }
        }
        let data = {
            colorkey: colorid,
            sizekey: sizeid,
            items: items,
            colorinfo: colorinfo,
            sizeinfo: sizeinfo,
            rowid: rowid,
            currowid: currowid,
            datainfo: datainfo,
            rowmode: true
        };
        if (!useCheck) {
            doApply(data, 0)
        } else {
            //副資材の場合使用不可SKUチェック
            SMaterialTargetSKU(data,0 )
        }
    }
    function SMaterialTargetSKU(param, mode) {
        try {
            var sku = [];
            for (let i = 0; i < param.items.length; i++) {
                sku.push({"color":param.items[i].color.m_smatl_color_no, "size":param.items[i].size.m_smatl_size_no});
            }
            fnc.current.postaxios('common/GetEnabledSKU',
                {
                    "rowdata": sku,
                    "code": key,
                },
                {
                    onSuccess: function (data) {
                        if (data.rowdata.length === 0) {
                            fnc.current.warnmsg("有効なSKUが存在しません");
                            fnc.current.wait(false);
                            return;
                        }
                        if (param.items.length !== data.rowdata.length) {
                            //有効なSKUを抽出
                            var newitem = [];
                            for (let i = 0; i < param.items.length; i++) {
                                if (data.rowdata.some(e => e.color === param.items[i].color.m_smatl_color_no && e.size === param.items[i].size.m_smatl_size_no)) {
                                    newitem.push(param.items[i]);
                                }
                            }
                            param.items = newitem;
                        }
                        doApply(param, mode)
                        fnc.current.wait(false);
                    }
                })
        } catch (error) {
            console.log(error);
        }
    }

    function toolpanel() {
        settoolpanels([
            {
                id: 'columns',
                labelDefault: '',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
                toolPanelParams: {
                    suppressRowGroups: true,
                    suppressValues: true,
                    suppressPivots: true,
                    suppressPivotMode: true,
                    suppressColumnExpandAll: true,
                },
            },
            {
                id: 'customStats_search',
                labelDefault: '',
                labelKey: 'customStats',
                iconKey: 'custom-tools',
                toolPanel: CustomToolPanel,
                toolPanelParams: {
                    useSearchPanel: useSearchPanel,
                    fnc: fnc,
                    dataid: dataid(value),
                    type:"1000",
                    savelayout: savelayout,
                    calllayout: calllayout
                },
            },
            {
                id: 'customStats2_search',
                labelDefault: '',
                labelKey: 'customStats2',
                iconKey: 'custom-tools2',
                toolPanel: CustomToolorgPanel,
                toolPanelParams: {
                    fnc: fnc,
                    dataid: props.controller,
                    subkey: props.subkey,
                    type: "1000",
                },
            },
        ]);
    }

    function onHandleClose() {
        fnc.current.searchlistclose();
    };

    function curgridApi() {
        return value === "0" ? apiRefcolor.current.grid : apiRefsize.current.grid;
    }
     //AG-grid event
    function onGridReady(params, type) {
        if (type === "0" && isEmpty(apiRefcolor.current.grid)) {
            apiRefcolor.current.grid = params.api;
            apiRefcolor.current.column = params.columnApi;
        }
        if (type === "1" && isEmpty(apiRefsize.current.grid)) {
            apiRefsize.current.grid = params.api;
            apiRefsize.current.column = params.columnApi;
        }
    }
    function onCellDoubleClicked(params) {
        curgridApi().deselectAll();
        Execute(2, params.node);
    }
    function onSelectionChanged(param) {
        onGridReady(param, value);
        var nodes = param.api.getSelectedNodes();
        if (nodes.length === 0) {
            if (value === "0") {
                setcolorlists([]);
                if (sizelists.length === 0) {
                    setshowselect(false);
                    return;
                }
            }
            else {
                setsizelists([]);
                if (colorlists.length === 0) {
                    setshowselect(false);
                    return;
                }
            }
        }
        let list = DeepCopy(value==="0"?colorlists:sizelists);
        let newlist = [];
        for (let i = 0; i < nodes.length; i++) {
            newlist.push(nodes[i].data);
        };
        let del = arrayDiff(list, newlist);     //旧リストと新リストの差（削除分）
        list = arrayDiff(list, del);            //旧リストと削除分の差
        let add = arrayDiff(newlist, list);     //新リストと旧リストの差（追加分）
        list = list.concat(add);
        setshowselect(true);
        if (value === "0") setcolorlists(list);
        else setsizelists(list);
    }
    //選択リスト削除
    function deSelect(code, type) {
        let list = DeepCopy(type==="0"?colorlists:sizelists);
        let target = list.filter(e => e.code === code);
        if (target.length !== 0 && value === type) {
            if (type === "0") {
                let node = apiRefcolor.current.grid.getRowNode(target[0].rowid);
                if (node !== null) node.setSelected(false);
            } else {
                let node = apiRefsize.current.grid.getRowNode(target[0].rowid);
                if (node !== null) node.setSelected(false);
            }
        }
        list = list.filter(e => e.code !== code);
        if (type === "0") setcolorlists(list);
        else setsizelists(list);
        if (list.length !== 0) setshowselect(true);
        else {
            if (type === "0") setshowselect(sizelists.length !== 0)
            else setshowselect(colorlists.length !== 0)
        }
    }


    function storagekey(type) {
        return dataid(type) + "_select";
    }
    const onFirstDataRendered = useCallback((params) => {
        if (getglobaldata(colfixkey)) {
            AGRef.current.AutoSizeColumns(false, params.ColumnAPI);
        }
    }, []);
    //列幅変更
    function ColumnResized(param) {
        if (param.finished) {
            ColumninfoAppy();
        }
    }
    //列情報保存
    function ColumninfoAppy() {
        if (!AGRef.current) return;
        AGRef.current.SaveColState(storagekey(value));
    //    if (!gridRef.current?.columnApi) return;
    //    if (value === "0")
    //        setcolorColumns(AGRef.current.GetApplyColumnDefs(colorcolumns, apiRefcolor.current.column));
    //    else
    //        setsizeColumns(AGRef.current.GetApplyColumnDefs(sizecolumns, apiRefsize.current.column));
    }
    function getContextMenuItems(params) {
        var result = [];
        if (rowSelection !== "single") {
            result.push(
                {
                    name: '全選択',
                    action: function () {
                        params.api.selectAllFiltered();
                   },
                });
            result.push(
                {
                    name: '選択解除',
                    action: function () {
                        params.api.deselectAll();
                    },
                });
            result.push(
                {
                    name: '選択行反転',
                    action: function () {
                        params.api.forEachNodeAfterFilter(node => node.isSelected() ? node.setSelected(false) : node.setSelected(true));
                   },
                });
        }
        return result;
    };
    function getMainMenuItems(params) {
        const athleteMenuItems = params.defaultItems.slice(0);
        athleteMenuItems.pop(); //Reset column削除
        athleteMenuItems.pop();
        return athleteMenuItems;
    };
    function valueFormatter(params, type) {
        onGridReady(params, type);
        if (params.value === '') return params.value;
        let colinfo = params.colDef.colinfo;
        if (colinfo === null) return params.value;
        try {
            if (colinfo.datatype === CELLTYPE.NUM) {
                var number = Number(params.value);
                if (number === 0 && colinfo.format.indexOf('showzero') === -1) {
                    return "-";
                }
                if (colinfo.format.indexOf('unuseGrouping') !== -1) return number.toString(); //カンマ区切りなし
                if (colinfo.decimalplace === 0) {
                    return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
                } else {
                    return number.toLocaleString(undefined, {
                        minimumFractionDigits: colinfo.decimalplace,
                        maximumFractionDigits: colinfo.decimalplace
                    });
                }
            }
            if (colinfo.datatype === CELLTYPE.MASTER) {
                if (!isEmpty(colinfo.dbcolumn)) {
                    return params.value + ":" + params.data[params.colDef.colId + "_nm"];
                }
                return params.value;
            }
            if (colinfo.datatype === CELLTYPE.SELECT) {
                let result = colinfo.options.find(e => e.code === params.value.toString());
                if (!isEmpty(result))
                    return params.value + ":" + result.name;
                return params.value;
            }
        } catch {
            return params.value;
        }
        return params.value;
    }

    function TabChange(event, newAlignment) {
        if (newAlignment !== null) {
            setValue(newAlignment);
        }
    };

    const colorColumnDefs = useMemo(
        () =>
            colorcolumns.map((column) => ({
                ...column,
                cellRenderer:
                    column.datatype === CELLTYPE.TAG ||
                        column.datatype === CELLTYPE.COLOR
                        ? TagRenderer
                        : undefined,
                valueFormatter: (param) => valueFormatter(param, "0"),
            })),
        [colorcolumns, valueFormatter]
    );

    const sizeColumnDefs = useMemo(
        () =>
            sizecolumns.map((column) => ({
                ...column,
                cellRenderer:
                    column.datatype === CELLTYPE.TAG ||
                        column.datatype === CELLTYPE.COLOR
                        ? TagRenderer
                        : undefined,
                valueFormatter: (param) => valueFormatter(param, "1"),
            })),
        [sizecolumns, valueFormatter]
    );

    return (
        <div>
            <Drawer anchor={"right"} open={show} onClose={onHandleClose} BackdropProps={{ invisible: true }}>
                <div style={{ marginRight: 10 }}>
                    <div style={{ textAlign: 'left', float: 'left', marginTop:  10, marginLeft: 10}}>
                        <span>SKU</span><span style={{ marginLeft: 30 }}>{ key}</span>
                    </div>
                   <div style={{ textAlign: 'right', marginTop: 10 }} >
                        <Button variant="outlined" size="small" onClick={() => Execute(0)}>適用</Button>
                        <Button variant="outlined" size="small" onClick={AllExecute}>全SKU適用</Button>
                        <Button variant="outlined" size="small" onClick={onHandleClose}>中止</Button>
                    </div>
                </div>
                <ToggleButtonGroup
                    color="primary"
                    value={value}
                    exclusive
                    onChange={TabChange}
                    size="small"
                >
                    <ToggleButton value="0">COLOR</ToggleButton>
                    {!sku?null:
                        <ToggleButton value="1">SIZE</ToggleButton>
                    }
                </ToggleButtonGroup>
                <div className="ag-theme-balham" style={{ height: '100%', width: 600 }}>
                    {value === "0" ?
                        <AgGridReact
                            theme={themeBalham}
                            columnMenu="legacy"
                            getRowId={params => params.data.code}
                            icons={icons}
                            sideBar={{
                                toolPanels: toolpanels
                            }}
                            onGridReady={(param)=>onGridReady(param, "0")}
                            onFirstDataRendered={onFirstDataRendered}
                            headerHeight={30}
                            modules={[AllCommunityModule, AllEnterpriseModule]}
                            getRowNodeId={RowNodeId}
                            multiSortKey={'ctrl'}
                            defaultColDef={defaultColDef}
                            getMainMenuItems={getMainMenuItems}
                            getContextMenuItems={getContextMenuItems}
                            rowSelection={rowSelection}
                            rowMultiSelectWithClick={true}
                            onCellDoubleClicked={onCellDoubleClicked}
                            onColumnResized={ColumnResized}
                            onColumnVisible={ColumninfoAppy}
                            onColumnPinned={ColumninfoAppy}
                            onColumnMoved={ColumninfoAppy}
                            onSelectionChanged={onSelectionChanged}
                            rowData={colorrowData}
                            columnDefs={colorColumnDefs}>
                        </AgGridReact>
                        :
                        <AgGridReact
                            theme={themeBalham}
                            columnMenu="legacy"
                            getRowId={params => params.data.code}
                            icons={icons}
                            sideBar={{
                                toolPanels: toolpanels
                            }}
                            onGridReady={(param)=>onGridReady(param,"1")}
                            onFirstDataRendered={onFirstDataRendered}
                            headerHeight={30}
                            modules={[AllCommunityModule, AllEnterpriseModule]}
                            getRowNodeId={RowNodeId}
                            multiSortKey={'ctrl'}
                            defaultColDef={defaultColDef}
                            getMainMenuItems={getMainMenuItems}
                            getContextMenuItems={getContextMenuItems}
                            rowSelection={rowSelection}
                            rowMultiSelectWithClick={true}
                            onCellDoubleClicked={onCellDoubleClicked}
                            onColumnResized={ColumnResized}
                            onColumnVisible={ColumninfoAppy}
                            onColumnPinned={ColumninfoAppy}
                            onColumnMoved={ColumninfoAppy}
                            onSelectionChanged={onSelectionChanged}
                            rowData={sizerowData}
                            columnDefs={sizeColumnDefs}>
                        </AgGridReact>
                    }
                </div>
                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={showselect}
                    ContentProps={{
                        classes: {
                            root: classes.snackbar
                        }
                    }}
                    message={
                        <React.Fragment>
                            <div style={{ maxHeight: 100, overflow: 'auto', marginTop: 5, width: 250 }}>
                                <div style={{ display: 'inline-block', width: '50%', verticalAlign:"Top"}}>
                                { colorlists.map(item => (
                                    <div>
                                        <IconButton
                                            color="inherit"
                                            sx={{ mr: 10 }}
                                            size="small"
                                            onClick={()=>deSelect(item.code, "0")}
                                        >
                                            <span class="material-icons editlink">close</span>
                                        </IconButton>
                                        <span>{item.code}</span>
                                    </div>
                                ))}
                            </div>
                                <div style={{ display: 'inline-block', width: '50%', varticalAlign:"Top"}}>
                                    {sizelists.map(item => (
                                        <div>
                                            <IconButton
                                                color="inherit"
                                                sx={{ mr: 10 }}
                                                size="small"
                                                onClick={() => deSelect(item.code, "1")}
                                            >
                                                <span class="material-icons editlink">close</span>
                                            </IconButton>
                                            <span>{item.code}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </React.Fragment>
                    }
                />
            </Drawer>
            <ComFunc ref={fnc} />
            <AGFunc
                ref={AGRef}
            />
        </div>
    );
};
